
import React from 'react'

import Paper from 'material-ui/Paper';

import { feedback as ROLES_CONFIG } from '../../../../config/roles';
import FeedbackResponses from '../../../../components/feedback/FeedbackResponses';

export default class FeedbackResponse extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      role: this.props.authenticated ? this.props.authenticated.role : null,
      _id: this.props && this.props.match && this.props.match.params ? this.props.match.params.id : ''
    }
  }

  render() {
    return (
      <div id="content">
        <div className="row mr-3vw">
          {
            ROLES_CONFIG.feedbackResponses.indexOf(this.state.role) != -1 ?
              <Paper className="col-sm-12 ml-2vw h-100 mt-1vw p-0 customShadow" zDepth={3}>
                {
                  this.state._id && this.state._id !== '' ?
                    <FeedbackResponses templateId={this.state._id} />
                  : null
                }
              </Paper> 
            : null
          }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./routes/app/routes/feedback/FeedbackResponse.js